import { render } from "./PersonalTicket.vue?vue&type=template&id=4cc5b804&scoped=true"
import script from "./PersonalTicket.vue?vue&type=script&lang=js"
export * from "./PersonalTicket.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=4cc5b804&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc5b804"]])

export default __exports__